module.exports = __webpack_public_path__ + "img/google_store.8c0b029.png";